ACC.common = {

	refreshScreenReaderBuffer: function ()
	{
		// changes a value in a hidden form field in order
		// to trigger a buffer update in a screen reader
		$('#accesibility_refreshScreenReaderBufferField').attr('value', new Date().getTime());
	},

	bindAll: function ()
	{
		ACC.common.bindToUiCarouselLink();
		//ACC.common.showQuickViewBox();
	},

	bindToUiCarouselLink: function ()
	{	
		$(".popup").colorbox({
			onComplete: function ()
			{
				ACC.common.refreshScreenReaderBuffer();
				$.colorbox.resize()
				
			},

			onClosed: function ()
			{
				ACC.common.refreshScreenReaderBuffer();
			}
		});
		
	},
/*
	showQuickViewBox: function ()
	{

		$("a.quickViewBox").colorbox({
			onComplete : function() {
				ACC.common.refreshScreenReaderBuffer();
				$.colorbox.resize()
				ACC.product.initQuickviewLightbox();
			},

			onClosed : function() {
				ACC.common.refreshScreenReaderBuffer();
			}
		});
	}
*/
};

$(document).ready(function ()
{
	ACC.common.bindAll();
});

// add a CSRF request token to POST ajax request if its not available
$.ajaxPrefilter(function (options, originalOptions, jqXHR)
{
	// Modify options, control originalOptions, store jqXHR, etc
	if (options.type === "post" || options.type === "POST")
	{
		var noData = (typeof options.data === "undefined");
		if (noData || options.data.indexOf("CSRFToken") === -1)
		{
			options.data = (!noData ? options.data + "&" : "") + "CSRFToken=" + ACC.config.CSRFToken;
		}
	}
});